export var AuthTokenFields;
(function (AuthTokenFields) {
    AuthTokenFields["UserId"] = "https://lendi/userId";
    AuthTokenFields["Type"] = "https://lendi/type";
    AuthTokenFields["Brand"] = "https://lendi/brand";
    AuthTokenFields["AuthApplications"] = "authorized-applications";
    AuthTokenFields["AuthCustomer"] = "authorized-customer";
})(AuthTokenFields || (AuthTokenFields = {}));
//# sourceMappingURL=AuthTokenFields.js.map